import request from '@/utils/request'
import downloadData from '@/utils/download'
// 日程回答-日程調整依頼詳細-情報(協力会社)
export function scheduleAdjustmentInfo(requestDetailId) {
  return request({
    url: `/api/scheduleAdj/partner/${requestDetailId}`,
    method: 'get',
  })
}
// 日程回答-候補日リスト
export function candidateDate(requestDetailId) {
  return request({
    // url: `/api/scheduleAdjAnswer/partner/candidate/date/${requestDetailId}`,
    url: `/api/scheduleAdjDetail/candidate/date/${requestDetailId}`,
    method: 'get',
  })
}
// 日程回答-見積情報ダウンロード
export function download(data) {
  return request({
    url: `/api/scheduleAdjAnswer/partner/download`,
    method: 'post',
    data,
  })
}
// 日程回答-提出
export function submitSchedule(data) {
  return request({
    url: `/api/scheduleAdjRequestDetail/partner/answer/schedule`,
    method: 'post',
    data,
  })
}
// 工事日程回答(SC1)-日程調整依頼詳細情報
export function scheduleAdjustmentInfoSC1(requestDetailId) {
  return request({
    url: `/api/scheduleAdjSc1/request/detail/${requestDetailId}`,
    method: 'get',
  })
}
// 工事日程回答(SC1)-日程調整SC1
export function partnerSc1(requestDetailId) {
  return request({
    url: `/api/scheduleAdjSc1/sc1/${requestDetailId}`,
    method: 'get',
  })
}
// 工事日程回答(SC1)-工事日程情報
export function scheduleList(requestDetailId) {
  return request({
    // url: `/api/scheduleAdjConstructionAnswer/partner/sc1/schedule/list/${requestDetailId}`,
    url: `/api/scheduleAdjDetail/candidate/date/${requestDetailId}`,
    method: 'get',
  })
}
// 工事日程回答(SC1)-提出
export function subumitScheduleSc1(data) {
  return request({
    // url: `/api/scheduleAdjConstructionAnswer/partner/submit/schedule/sc1`,
    url: `/api/scheduleAdjRequestDetail/partner/answer/schedule/sc1`,
    method: 'post',
    data,
  })
}
export function completedScheduleSc1(data) {
  return request({
    url: `/api/scheduleAdjRequestDetail/partner/adjust/completed/so`,
    method: 'post',
    data,
  })
}
// 日程回答-カレンダー
export function calendar(data) {
  return request({
    url: `/api/scheduleAdjAnswer/partner/calendar`,
    method: 'post',
    data,
  })
}
// 工事日程回答(SC1)-カレンダー
export function calendarSc1(data) {
  return request({
    url: `/api/scheduleAdjAnswer/partner/calendar`,
    method: 'post',
    data,
  })
}
// 依頼情報取得
export function getRequestDocumentsInfo(requestDetailId) {
  return request({
    url: `/api/scheduleAdj/partner/${requestDetailId}`,
    method: 'get',
  })
}
// 依頼情報取得
export function updateBook(data) {
  return request({
    url: `/api/scheduleAdj/partner/update`,
    method: 'post',
    data,
  })
}
// 共有資料ダウンロード
export function downloadCommonData(data) {
  downloadData.resource(`/api/requestDocuments/share/download`, data)
}
// 共有資料リスト情報を取得
export function reqDocMany(data) {
  return request({
    // url: `/api/scheduleAdjAnswer/partner/reqDoc/many`,
    url: `/api/requestDocuments/share/reqDoc/many`,
    method: 'post',
    data,
  })
}
// 日程回答-見積情報ダウンロード
export function estimateDownload(data) {
  return request({
    url: `/api/scheduleAdjAnswer/partner/estimate/download`,
    method: 'post',
    data,
  })
}
// 日程回答-見積協力依頼ウェブインタフェースクラス(SC1)
export function estimateCooperateInfo(estimateCooperateId) {
  return request({
    url: `/api/estimateCooperate/getOne/${estimateCooperateId}`,
    method: 'get',
  })
}
// 日程回答-見積協力依頼ウェブインタフェースクラス(SC3)
export function estimateBriefBaseInfo(demandBaseId) {
  return request({
    url: `/api/estimateBriefBase/getOne/${demandBaseId}`,
    method: 'get',
  })
}
